<template>
  <div style="padding-top: 60px; font-size: 0.32rem">
    <div class="header" style="position: fixed">
      <div class="header-left">
        <a @click="$router.back()" class="header-back"></a>
      </div>
      <div class="header-center">
        <h4 class="header-title">转账</h4>
      </div>
      <div class="header-right">
        <a @click="$parent.openKefu" id="gocs_btn" class="header-helper"></a>
      </div>
    </div>
    <div id="transfer_div" class="mod-transfer">
      <div class="bgWhite p15 mt10">
        <div id="accinfo">
          <p>主账户：</p>
          <h3 id="balance">{{ $store.state.userInfo.balance }}</h3>
          <a id="recover_btn" @click="transall"><input type="button" value="一键回收" style="font-size: 0.24rem" class="btn-sub" /></a>
          <a id="refreshAmount_btn" @click="getBalances"><input type="button" class="btn-sub" style="font-size: 0.24rem" value="刷新金额" /></a>
          <div style="display: flex; align-items: center">
            免转模式
            <van-switch style="margin-left:30px" @change="changeTasfer()" :active-value="1" :inactive-value="0" v-model="$store.state.userInfo.transferstatus" size="24px" />
          </div>
        </div>

        <ul id="gplist" class="grid-layout clearfix">
          <li class="no-next"  v-for="(item, index) in balancelist" :key="index" @click="changVal(item)" v-if="item.platname != 'userbalance' && showNum >=index" style="display: list-item"><span class="tit">{{ item.name }}</span><span class="bl f14px cRed" id="balance" style="display:block">{{ item.balance }}</span></li>
        </ul>
        <a href="javascript:void(0);" @click="changeshowNum" id="gpExpandBtn">{{showNum == 4 ? '展开全部':"收起"}}</a>
      </div>

      <ul class="selection mt10" v-if="$store.state.userInfo.transferstatus != 1">
        <li>
          <h4>请选择转账平台</h4>
          <a href="javascript:void(0);" id="selectout" @click="changShow('sourcetype')" class="mt15">
            <p  class="f14px mpicker-control" id="transferOut">{{ sourcetype.name || '转出'}} </p>
          </a>
        </li>
        <li class="icon-arrow"></li>
        <li>
          <span>选择账户不可一样</span>
          <a href="javascript:void(0);" @click="changShow('targettype')" id="selectin" class="mt15">
            <p class="f14px mpicker-control" id="transferIn">{{ targettype.name || '转入'}}</p>
          </a>
        </li>
      </ul>

      <ul class="mod-forms-inputamt mt10" v-if="$store.state.userInfo.transferstatus != 1">
        <li>
          <h4>请输入转账金额</h4>
          <div>
            <input type="text" v-model="amount"  name="amount" id="amount" maxlength="50" class="txt-ipt" placeholder="输入转账金额" />
            <a id="fullAmount_btn" @click="amount = $store.state.userInfo.balance"><input type="button" value="全部金额" class="btn-sub" /></a>
          </div>
        </li>
      </ul>

      <div class="p15 mtb15" v-if="$store.state.userInfo.transferstatus != 1">
        <input type="button"  @click="btnOk" id="transferNow_btn"  class="confirm-sub" value="立即转账" />
      </div>
    </div>
        <!-- 额度转换 -->
    <van-action-sheet v-model="openShow" title="额度转换">
      <div class="content">
        <van-form>
          <van-field v-model="$store.state.userInfo.balance" disabled label="平台账户余额" placeholder="平台账户余额" />
          <van-field v-model="openInfo.balance" disabled label="游戏账户余额" placeholder="游戏账户余额" />
          <van-field v-model="amount" name="操作金额" label="操作金额" placeholder="填写操作金额" />
          <van-field name="radio" label="转账方式">
            <template #input>
              <van-radio-group v-model="payType" direction="horizontal">
                <van-radio :name="0">转入</van-radio>
                <van-radio :name="1">转出</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <div style="margin: 16px">
            <van-button @click="isOk" round block type="info" native-type="submit">提交</van-button>
          </div>
        </van-form>
      </div>
    </van-action-sheet>
    <!-- 列表选择 -->
        <van-popup v-model="show" position="bottom" v-if="type == 'sourcetype' && show" :style="{ height: '70%', background: '#f8f8f8' }" class="card">
      <div class="poptit">选择钱包</div>
      <div style="height: 0.2rem"></div>
      <div style="background: #fff; width: 100%; margin: 0 auto; padding: 0 20px; box-sizing: border-box">
        <div class="lis" v-for="(item, index) in balancelist" :key="index" @click="changApiType('sourcetype', item)">
          <div>{{ item.name }}</div>
          <img v-if="sourcetype.name == item.name" src="/static/image/icon_chose.28d0a1732f077f8062a64082a086ebf2.png" alt="" />
        </div>
      </div>
    </van-popup>
        <van-popup v-model="show" position="bottom" v-if="type == 'targettype' && show" :style="{ height: '70%', background: '#f8f8f8' }" class="card">
      <div class="poptit">选择钱包</div>
      <div style="height: 0.2rem"></div>
      <div style="background: #fff; width: 100%; margin: 0 auto; padding: 0 20px; box-sizing: border-box">
        <div class="lis" v-for="(item, index) in balancelist" :key="index" @click="changApiType('targettype', item)">
          <div>{{ item.name }}</div>
          <img v-if="targettype.name == item.name" src="/static/image/icon_chose.28d0a1732f077f8062a64082a086ebf2.png" alt="" />
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
export default {
  name: 'transfer',
  data() {
    return { nshow: true, balancelist: [], openInfo: {}, amount: null, payType: 0, openShow: false, daoTime: null ,showNum:4,show: false, type: 'sourcetype', sourcetype: { platname: 'userbalance', name: '平台钱包' }, targettype: {}};
  },
  created() {
    let that = this;
    that.getbalancelist();
    that.daoTime = setInterval(() => {
      that.getbalancelistNoLoding();
    }, 1500);
  },
  methods: {
        btnOk() {
      let that = this;
      if (that.amount == null || that.amount == '') {
        that.showTost(0, '请输入操作金额！');
        return;
      }
      if(that.sourcetype.platname != 'userbalance' && that.targettype.platname !='userbalance'){
        that.showTost(0, '场馆内钱包不支持互转');

        return
      }
      if(!that.targettype.name){
            that.showTost(0, '请选择转入平台');

        return
      }
      let info = { amount: that.amount, sourcetype: that.sourcetype.platname, targettype: that.targettype.platname };

      that.showLoading();
      that.$apiFun.post('/api/transfer', info).then(res => {
        that.showTost(1, res.message);

        if (res.code === 200) {
          that.refreshusermoney();
          that.getbalancelist();
          that.amount = null;
        } else {
          that.hideLoading();
        }
      }) .catch(res => {
          that.$parent.hideLoading();
        });
    },
        changShow(name) {
      this.type = name;
      this.show = true;
   
    },
        changApiType(name, val) {
      let that = this;
      that[name] = val;
      that.show = false;
      if(name == 'sourcetype'){
        that.amount = null;

      }
    },
    changeshowNum(){
      let that = this;
      let num = that.showNum;
      if(num == 4){
        that.showNum = that.balancelist.length
      }else{
        that.showNum = 4
      }
    },
    isOk() {
      let that = this;

      let sourcetype = '';
      let targettype = '';

      if (that.payType == 0) {
        //转入游戏
        sourcetype = 'userbalance';
        targettype = that.openInfo.platname;
      } else {
        //转入平台
        sourcetype = that.openInfo.platname;
        targettype = 'userbalance';
      }
      let info = { amount: that.amount, sourcetype: sourcetype, targettype: targettype };
      if (that.amount == null) {
        that.showTost(0, '请输入操作金额！');
        return;
      }
      that.closeCv();

      that.showLoading();
      that.$apiFun.post('/api/transfer', info).then(res => {
        that.showTost(1, res.message);

        if (res.code === 200) {
          that.refreshusermoney();
          that.getbalancelist();
        } else {
          that.hideLoading();
        }
      });
    },
    closeCv() {
      let that = this;
      that.openInfo = {};
      that.amount = null;
      that.openShow = false;
    },
    refreshusermoney() {
      let that = this;
      that.$apiFun.post('/api/refreshusermoney', {}).then(res => {
        that.hideLoading();
        if (res.code == 200) {
          localStorage.setItem('userInfo', JSON.stringify(res.data));
          that.$store.commit('changUserInfo');
        }
      });
    },
    getBalances() {
      let that = this;
      that.showLoading();
      that.getbalancelist();

      that.$apiFun
        .post('/api/balance', {})
        .then(res => {
          if (res.code == 200) {
            let userInfo = JSON.parse(localStorage.getItem('userInfo'));
            userInfo.balance = res.data.balance;
            userInfo.gameblance = res.data.gameblance;
            localStorage.setItem('userInfo', JSON.stringify(userInfo));
            that.$store.commit('changUserInfo');
          }
          that.hideLoading();
        })
        .catch(res => {
          // console.log(res)
          that.hideLoading();
        });
    },
    changeTasfer() {
      let that = this;
      that.$parent.showLoading();
      let userInfo = JSON.parse(localStorage.getItem('userInfo'));
      let mianzhuan = userInfo.transferstatus ? 0 : 1;
        that.showNum = 4

      that.$apiFun
        .post('/api/uptransferstatus', { transferstatus: mianzhuan })
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            userInfo.transferstatus = mianzhuan;
            localStorage.setItem('userInfo', JSON.stringify(userInfo));
            that.$store.commit('changUserInfo');
            that.$parent.showTost(1, '操作成功！');
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    changVal(item) {
      let that = this;
      // $store.state.userInfo.transferstatus == 0  0  转账模式  1免转模式
      if (that.$store.state.userInfo.transferstatus == 1) {
        return;
      }
      that.openInfo = item;
      that.openShow = true;
      that.amount = null;
    },
    close() {
      that.openInfo = {};
      that.openShow = false;
      that.amount = null;
    },
    getbalancelist() {
      let that = this;
      that.$parent.showLoading();

      that.$apiFun
        .post('/api/balancelist', {})
        .then(res => {
          if (res.code !== 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code === 200) {
            
            let balancelist = res.data;
            balancelist.unshift({ platname: 'userbalance', name: '平台钱包' });
             balancelist.forEach(element => {
              element.balance = '读取中..';
            });
            that.balancelist = balancelist;
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    getbalancelistNoLoding() {
      let that = this;

      that.$apiFun
        .post('/api/balancelist2', {})
        .then(res => {
          if (res.code !== 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code === 200) {
            that.balancelist = res.data;
            let balancelist = res.data;
            balancelist.unshift({ platname: 'userbalance', name: '平台钱包' });
            that.balancelist = balancelist;
          }
        })
        .catch(res => {});
    },
    transall() {
      let that = this;
      that.showLoading();
      that.$apiFun
        .post('/api/transall', {})
        .then(res => {
          that.showTost(1, res.message);
          that.getbalancelist();
          that.refreshusermoney();
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    showLoading() {
      this.$parent.showLoading();
    },
    hideLoading() {
      this.$parent.hideLoading();
    },
    openKefu() {
      this.$parent.openKefu();
    },
    showTost(type, title) {
      this.$parent.showTost(type, title);
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {
    let that = this;
    if (that.daoTime) {
      clearInterval(that.daoTime);
    }
    that.daoTime = null;
  },
};
</script>
<style lang="scss" scoped>
.card {
  .lis {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin: 0 auto;
    box-sizing: border-box;
    height: 1.2rem;
    border-bottom: 1px solid #f8f8f8;
    img {
      width: 0.4rem;
    }
  }
}
.poptit {
  height: 1.4rem;
  font-size: 0.4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  position: sticky;
  top: 0;
  z-index: 22;
}
</style>



// WEBPACK FOOTER //
// src/components/transfer.vue